import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchGet } from '../cruds/remote';
import WithRoles from '../components/container/WithRole';
import getLabel from '../translations/messages';
import './Home.css';

const HomeCard = (props, context) => (
  <div className="HomeCard">
    <div className="title">{getLabel(context.locale, props.title)}</div>
    <div className="content">{props.content}</div>
  </div>
);

HomeCard.contextTypes = {
  locale: PropTypes.string,
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    fetchGet('home')
      .then(res => this.setState(res));
  }

  render() {
    const { users, departments, substances, dsTotal, dsToBeEvaluated, dsEvaluated } = this.state;

    return (
      <div className="Home">
        <WithRoles roles={['A', 'B', 'C', 'D']}>
          <div className="content">
            <div className="card-row">
              <HomeCard title="home.users" content={users} />
              <HomeCard title="home.departments" content={departments} />
              <HomeCard title="home.substances" content={substances} />
            </div>
            <div className="card-row">
              <HomeCard title="home.departmentSubstances" content={dsTotal} />
              <HomeCard title="home.departmentSubstancesToBeEval" content={dsToBeEvaluated} />
              <HomeCard title="home.departmentSubstancesEvaluated" content={dsEvaluated} />
            </div>
          </div>
        </WithRoles>
      </div>
    );
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/main/pages/Home.js